module.exports = __webpack_public_path__ + "img/4bed95b.jpg";